import type { QueryClient } from "react-query";
import { PROFILE_PAGES } from "@/react/helpers/memberHelper";
import { PROFILE_INFO_QUERY_KEY } from "@/react/hooks/profile/useProfileInfo";

export const generateInvalidateMemberQueryKey = (memberPublicId: string) => [
  PROFILE_INFO_QUERY_KEY,
  memberPublicId,
  {
    page_name: PROFILE_PAGES.PROFILE_VIEW,
  },
];

/**
 * Invalidates all member-related queries after connection state changes in connections
 * This includes individual member queries and member search results
 */
export const invalidateAllMemberQueries = async (
  queryClient: QueryClient,
  memberPublicId: string,
) => {
  await Promise.all([
    queryClient.invalidateQueries("recommendations"),
    queryClient.invalidateQueries(
      generateInvalidateMemberQueryKey(memberPublicId),
    ),
    queryClient.invalidateQueries("community-members"),
    queryClient.invalidateQueries("audience"),
  ]);
};
